import {
  SectionFlexColumn,
  SectionFlexRow,
} from "../../../../components/General";
import T from "../../../../components/Typography";
import { colors } from "../../../../styles";

export const SettingsSection = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div className="flex flex-col items-center">{children}</div>;
};

export const SettingHeader = ({ title }: { title: string }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: 60,
        backgroundColor: "#F2F4F7",
      }}
    >
      <T variant="headingSm" sx={{ paddingLeft: "16px" }}>
        {title}
      </T>
    </div>
  );
};

export const SettingTitle = ({ title }: { title: string }) => {
  return <T variant="mdMed">{title}</T>;
};

export const SettingSubTitle = ({ subtitle }: { subtitle: string }) => {
  return (
    <T variant="mdReg" color={colors.gray_600}>
      {subtitle}
    </T>
  );
};

export const SettingsItem = ({
  title,
  subtitle,
  leftSide,
  rightSide,
  handleOnClick,
  height = 60,
  showBottomBottomBorder = true,
}: {
  title: string;
  subtitle?: string;
  leftSide?: React.ReactNode;
  rightSide: React.ReactNode;
  handleOnClick?: () => void;
  height?: number;
  showBottomBottomBorder?: boolean;
}) => {
  return (
    <SectionFlexRow
      style={{
        height,
        width: "95%",
        display: "flex",
        justifyContent: "space-between",
        // margin: "0 16px",
        cursor: handleOnClick ? "pointer" : "default",
        borderBottom: showBottomBottomBorder
          ? `1px solid ${colors.gray_200}`
          : "none",
      }}
      onClick={handleOnClick}
    >
      {leftSide ? (
        leftSide
      ) : (
        <SectionFlexColumn>
          <SettingTitle title={title} />
          {subtitle && <SettingSubTitle subtitle={subtitle} />}
        </SectionFlexColumn>
      )}
      {rightSide}
    </SectionFlexRow>
  );
};
